module.exports = __webpack_public_path__ + "static/media/Exclamation Mark.82f27c4a.svg";